import {ifCanPushDatalayer} from './utils/utils.dataLayer.common';

const dataLayerCareerSavedJobs = (event) => {
	ifCanPushDatalayer({
		then: () => {

            const jobListingContainer = event.target.closest('div.coveo-list-layout.CoveoResult');

            if (jobListingContainer) {
                const jobListingTitle = jobListingContainer.querySelector('h5.title').innerText;
                const jobListingDepartment = jobListingContainer.querySelector('span.coveo-main-badge.career').innerText;
                const savedJobIconDiv = jobListingContainer.querySelector('div.saved-jobs-icon');

                if (savedJobIconDiv.classList.contains('is-saved')) {
                    dataLayerBus.push({
                        'event': 'saved_job_listing',
                        'job_listing': jobListingTitle,
                        'departement': jobListingDepartment
                    });
                } else {
                    dataLayerBus.push({
                        'event': 'unsaved_job_listing',
                        'job_listing': jobListingTitle,
                        'departement': jobListingDepartment
                    });
                }
            }
		}
	});
};

export default dataLayerCareerSavedJobs;